import { Component } from '@angular/core';

import { NotificationFeedService } from '@app/services/notifications/notification-feed.service';

/**
 * Topbar notification bell: the current user's notification feed (first type:
 * high-risk alerts). Opening the dropdown marks everything seen - viewing IS
 * dismissing for the bubble; the rows persist in the history page.
 */
@Component({
    selector: 'app-notification-bell',
    templateUrl: './notification-bell.component.html',
    standalone: false
})
export class NotificationBellComponent {
  constructor(public feed: NotificationFeedService) { }

  onOpenChange(isOpen: boolean): void {
    if (isOpen) {
      this.feed.markAllSeen();
    }
  }
}
